<div style="display: flex; justify-content: end">
  <button mat-icon-button [mat-dialog-close]="undefined" matTooltip="Fermer">
    <mat-icon>close</mat-icon>
  </button>
</div>
<div class="bloc-liste" style="width: 800px; height: 350px; margin-left: 10px; margin-right: 10px; border: 1px solid black">
  <p>
    <span>Service: {{ projetSource?.service }}</span>
  </p>
  <div class="wrapper">
    <div class="left_block">
      <fieldset style="width: 200px">
        <legend><b> Projet à débiter:</b> ({{ projetSource?.code }})</legend>
        <ul>
          <li><b>Projet à débiter:</b> {{ projetSource?.libelle }}</li>
          <li><b>Nature Analytique:</b> {{ natureAnalytiqueSource?.libelle }}</li>
          <li><b>Tranche:</b> {{ trancheSource?.libelle }}</li>
        </ul>
      </fieldset>
    </div>
    <div class="center_block">
      <fieldset style="width: 200px">
        <legend><b> Projet à créditer:</b> ({{ projetCible?.code }})</legend>
        <ul>
          <li><b>Projet à créditer:</b> {{ projetCible?.libelle }}</li>
          <li><b>Nature Analytique:</b> {{ natureAnalytiqueCible?.libelle }}</li>
          <li><b>Tranche:</b> {{ trancheCible?.libelle }}</li>
        </ul>
      </fieldset>
    </div>
    <div class="right_block">
      <ul>
        <li><b>Montant:</b> {{ montant | currency }}</li>
        <li><b>Commentaire demande:</b></li>
        <div class="commentaire">
          {{ commentaire }}
        </div>
      </ul>
    </div>
    <div style="width: 90%; float: left; height: 45px; margin-left: 10px; margin-top: 40px">
      <span><b>Demande refusée le:</b> {{ dateRefus | date }} </span>,
      <span><b>motif de refus:</b> {{ motifRefus }}</span>
    </div>
  </div>
</div>
